<template>
    <div class="load-bag" v-if="showLoader">
    <div class="lds-ripple" ><div></div><div></div></div>
    </div>
      <Dashboard/>
        <!-- Main Content -->
        <div class="main-content">
          <section class="section">
            <div class="section-header">
              <h1>Requested Users</h1>
              <div class="section-header-breadcrumb">
                <div class="breadcrumb-item active"><router-link to="/dashboard">Home</router-link></div>
                <div class="breadcrumb-item">Requested Users</div>
              </div>
            </div>
            <div class="section-body">
              <div class="row">
                <div class="col-12">
                  <div class="card">
                    <!-- <div class="card-header d-Fle">
                      <h4>Export Table</h4>
                    </div> -->
                    <div class="card-body">
                      <div class="table-responsive newPc">
                        <table
                          class="table table-bordered table-hover"
                          id="tableExport"
                          style="width: 100%"
                        >
                          <thead>
                            <tr>
                              <th>S No.</th>
                              <th>Name</th>
                              <th>Email ID</th>
                              <th>Contact No.</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item, index) in result" :key="item._id">
                              <td>{{ index + 1 }}</td>
                              <td>{{ item.name }}</td>
                              <td class="EmailID">{{ item.email }}</td>
                              <td v-if="item.mobile">{{ item.mobile }}</td>
                              <td v-else>--</td>
                              <td class="action">
                                <a data-toggle="modal" class="btn mr-1 btn-info"  @click="ViewUser(item._id)"
                                data-target=".view-user-modal"
                                >View</a>
                                <button class="btn mr-1 btn-success" v-on:click="accept(item._id)">Accept </button>
                                <button class="btn mr-1 btn-danger" v-on:click="reject(item._id)">Reject</button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
  
  
        <!-- View User Modal start -->
        <div
          class="modal fade view-user-modal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="myLargeModalLabel">User Details</h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                  <div class="custom-table">
                    <table class="table-bordered w-100">
          <tbody>
            
              <tr>
              <th class="p-3"><i class="fa fa-user" style="color:#16bc91e3"></i> &nbsp;Name</th>
              <td class="p-3">{{ this.viewname }}</td>
              </tr>
              <tr>
              <th class="p-3"><i class="fa fa-envelope" style="color:#16bc91e3"></i> &nbsp;Email</th>
              <td class="p-3">{{ this.viewemail }}</td>
              </tr>
              <tr>
              <th class="p-3"> <i class="fa fa-mobile" style="color:#16bc91e3"></i> &nbsp;&nbsp;Contact Number</th>
              <td class="p-3" v-if="this.viewphone_number">{{ this.viewphone_number }}</td>
              <td class="p-3" v-else>--</td>
              </tr>
              <tr>
              <th class="p-3" colspan="2"><i class="fa fa-file-invoice" style="color:#16bc91e3"></i> &nbsp;Documents</th>
            </tr>
            
              <tr>
             
              <td class="p-3" colspan="2"  v-if="this.viewimage_url.length!==0">
                <div class="row">
                <div v-for="item in viewimage_url" :key="item" class="col-md-4">
                 <a target="_blank" :href='item'> <img :src="item"   class="Image w-100"/></a>
                </div>
              </div>
              </td>
              <td class="p-3" v-else>No document provied</td>
              </tr>
              <button class="btn mx-1 my-2 btn-success"  v-on:click="accept(viewid)">Accept </button>
              <button class="btn mx-1 my-2 btn-danger" v-on:click="reject(viewid)">Reject</button>
          </tbody>
      </table>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <!-- View User Modal end -->
  
  </template>
  
  <script>
  import { defineComponent } from 'vue'
  import { createToast } from 'mosha-vue-toastify';
  import 'mosha-vue-toastify/dist/style.css'
  import Dashboard from '@/components/Dashboard.vue'
  import axios from "../services/customAxios";
  import { base_url } from "../config";
  export default defineComponent({
    name: 'UserManagement',
    components: {
      Dashboard
    },
    setup () {
      const toast = () => {
          createToast()
      }
      return { toast }
    },
    data(){
      return{
        result:[],       
        base_url: base_url,
        viewname:"",
        viewemail:"",
        viewimage_url:"",
        viewphone_number:"",
        viewid:"",
        showLoader: true,
        res:"",
        resultpay:[]
      }
    },
    methods:{
      async LoadUser() {
        try{
        let response = await axios.get(`${base_url}/get_all_requested_user`); 
        console.log("==========>>>>>",response.data.result);
        this.result = response.data.result;
      }
      catch (error) {
        if (error) {
          this.showLoader= false;
            this.result = [];
          }
        }
      },
      async accept(_id) {
        try{
          if (confirm("Are you sure you want to verify this user ?")) {
            let response = await axios.put(`${base_url}/update_status/` + _id ,{
                is_verified: 'accepted',
            });
            console.log(response.data);
            this.LoadUser();
            createToast({title: "Success", description: response.data.message},{type: "success"})
            if(response.data.success == true){
                window.location.reload();
              }
          }
            } catch(error){
            createToast({ description: error?.response?.data?.message},{type: "default"})
        }
        },
        async reject(_id) {
         try{
          if (confirm("Are you sure you want to reject this user ??")) {
            let response = await axios.put(`${base_url}/update_status/` + _id,{
                is_verified: 'rejected',
            });
            console.log(response.data);
            this.LoadUser();
            createToast({title: "Success", description: response.data.message},{type: "success"})
            if(response.data.success == true){
                window.location.reload();
              }
          }
         } catch(error){
            createToast({ description: error?.response?.data?.message},{type: "default"})
        }
        },
      async ViewUser(_id) {
        let response = await axios.get(`${base_url}/get_user/`+ _id); 
        console.log("=====View User=====>>>>>",response.data.result);
        this.viewname = response.data.result.name;
        this.viewemail = response.data.result.email;
        this.viewphone_number = response.data.result.mobile;
        this.viewid= response.data.result._id,
        this.viewimage_url= response.data.result.image_url
      },
    },
    async mounted(){
      this.LoadUser();
      this.ViewUser();
      let recaptchaScript = document.createElement('script');
      recaptchaScript.setAttribute('src', 'assets/pages/datatables.js');
      setTimeout(() => {
        document.body.appendChild(recaptchaScript)  
        this.showLoader= false
      }, 3500);
    }
  });
  </script>
  
  <style>
  /* .modal.show .modal-dialog{transform: translateY(20%);} */
  </style>